import useSWR from 'swr';
import axios from 'axios';

import { getApiUrl } from '@/helpers/api';

export const useUserActivityWaiverPdf = (userId, activityId) => {
  const urlStr = `${getApiUrl()}/mega/user-activity-waiver/${userId}/waiver-pdf?activityId=${activityId}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url, { responseType: 'blob' });
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const useUserActivityWaiver = (userId, activityId) => {
  const urlStr = `${getApiUrl()}/mega/user-activity-waiver/${userId}/activity/${activityId}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};
